import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { AuthService } from '../../../pages/user/services/auth.service';
import { LocalStorageService } from '../../../pages/user/services/local-storage.service';
import { DataSharingService } from '../../../pages/user/services/data-sharing.web.service';
import { CacheService } from '../../../shared/services/cache.service';
import { MenuSharedService } from '../menu/services/menu.shared.service';
import { AppRoutes } from '../../../shared/constants/routes/routes.constant';
import { getImageUrl, hasCustomProfilePhoto } from '../../../shared/utils/get-profile-pic';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  loggedUser: any;
  avatarUrl: SafeStyle | null = null;
  userInitials: string = '';
  menuCollapsed: boolean = true;

  constructor(
    private auth: AuthService,
    private router: Router,
    private localStorage: LocalStorageService,
    private dataSharingService: DataSharingService,
    private sanitizer: DomSanitizer,
    private cacheService: CacheService,
    private menuSharedService: MenuSharedService
  ) { }

  ngOnInit() {
    this.menuSharedService.getMenuCollapsed().subscribe((collapsed) => {
      this.menuCollapsed = collapsed;
    });

    this.loggedUser = this.localStorage.getObject('user');

    if (this.loggedUser && this.loggedUser.name) {
      this.userInitials = this.getInitials(this.loggedUser.name);
    }

    this.dataSharingService.getLoggedUserAvatar().subscribe((url) => {
      this.avatarUrl = url;
    });

    this.dataSharingService.getLoggedUserName().subscribe((name) => {
      if (name && this.loggedUser) {
        this.loggedUser = { ...this.loggedUser, name };
        this.userInitials = this.getInitials(name);
      }
    });

    this.publishAvatar();
  }

  /**
   * Publica a foto de perfil do usuario, quando ele tem uma. Usuarios sem foto
   * ficam com as iniciais: o backend grava um photo_id default em todos eles, e
   * a imagem por tras desse id ainda e o logo antigo.
   *
   * O photo_id manda na decisao porque o profile_photo_url guardado no
   * localStorage pode ser de uma sessao anterior, com a URL do avatar default.
   */
  private publishAvatar() {
    const photoId = this.loggedUser && this.loggedUser.photo_id;

    if (!hasCustomProfilePhoto(photoId)) {
      this.dataSharingService.setLoggedUserAvatar(null);
      return;
    }

    const url = this.loggedUser.profile_photo_url || getImageUrl(photoId, 55, 55);

    this.dataSharingService.setLoggedUserAvatar(
      this.sanitizer.bypassSecurityTrustStyle(`url(${url})`)
    );
  }

  getInitials(name: string): string {
    if (!name) return '';
    const names = name.trim().split(/\s+/).filter(n => n.length > 0);
    if (names.length === 0) return '';

    const firstChar = names[0].charAt(0).toUpperCase();
    const lastChar = names.length > 1 ? names[names.length - 1].charAt(0).toUpperCase() : '';
    return firstChar + lastChar;
  }

  toggleMenu() {
    this.menuSharedService.setMenuCollapsed(!this.menuCollapsed);
  }

  logout() {
    this.dataSharingService.setLoggedUserAvatar(null);
    this.menuSharedService.setMenuCollapsed(true);
    this.dataSharingService.setOrganizacaoData(null);
    this.dataSharingService.setTerminalLiberacaoData(null);
    this.cacheService.clearCache();
    this.router.navigate([AppRoutes.LOGOUT]);
    this.auth.logout();
  }
}
